import React from 'react';
import { Card } from '../../components/ui/Card';
const packages = [{
  name: '3-Class Renewal Package (select your own courses-9 hours)',
  credits: 9,
  price: '$49.95',
  hasDetails: false
}, {
  name: '3-Class Broker Management Clinic (Preset with BMC 1-2-3 for 9 hours)',
  credits: 9,
  price: '$54.95',
  hasDetails: true
}, {
  name: '3-Class Property Management BMC (Preset with BMC 1-2-3B for 9 hours)',
  credits: 9,
  price: '$54.95',
  hasDetails: true
}, {
  name: '6-Class Salesperson Renewal Package (select your own courses-18 hours)',
  credits: 18,
  price: '$69.95',
  hasDetails: false
}, {
  name: '6-Class FIRST TIME Renewal Package (Preset -18 Hours)',
  credits: 18,
  price: '$69.95',
  hasDetails: false
}, {
  name: '#1 8-Class Salesperson Renewal Package (Preset-24 hours)',
  credits: 24,
  price: '$89.95',
  hasDetails: true
}, {
  name: '#2 8-Class Salesperson Renewal Package (Preset-24 hours with NAR Ethics)',
  credits: 24,
  price: '$89.95',
  hasDetails: true
}, {
  name: '10-class Broker Renewal Package (Preset-30 hours with NAR Ethics)',
  credits: 30,
  price: '$104.95',
  hasDetails: true
}, {
  name: '10-Class Renewal Package for Property Management Brokers (Preset 30-hours with NAR Ethics and BMC #3B)',
  credits: 30,
  price: '$104.95',
  hasDetails: true
}];
const singleClasses = [{
  name: 'Ethics & The Rules (with NAR Code of Ethics)',
  creditType: 'Comm. Standards',
  credits: 3,
  description: "CS CE credit + Complies with current NAR cycle January 2025-December 2027 The Commissioner's",
  price: '$19.95'
}, {
  name: 'NAR Code of Ethics (NO CE CREDIT)',
  creditType: 'NONE',
  credits: 0,
  description: '(No CE Credit - No Clock Hours) Complies with current cycle January 2025-December 2027 REMEMBER-SEND',
  price: '$14.95'
}, {
  name: 'Deeds, Fires & Water: Be Prepared',
  creditType: 'General',
  credits: 3,
  description: 'Required to be Prepared (GEN)-NEW ADRE Class Requirement as of 2025 Our obligation',
  price: '$19.95'
}, {
  name: 'Are They Represented?',
  creditType: 'Agency Law',
  credits: 3,
  description: 'Are They Represented? (AL) This class will explore the history of agency disclosure, from sub agency',
  price: '$19.95'
}, {
  name: 'Mastering Agency Agreements',
  creditType: 'Agency Law',
  credits: 3,
  description: 'Mastering Agency Agreements (AL) Objective: Class will review the way real estate agency',
  price: '$19.95'
}, {
  name: 'A Letter From ADRE',
  creditType: 'Comm. Standards',
  credits: 3,
  description: 'A Letter From ADRE (CS) This course will review both the Arizona Revised Statutes and',
  price: '$19.95'
}, {
  name: "Don't Lose Your License",
  creditType: 'Comm. Standards',
  credits: 3,
  description: "Don't Lose Your License (CS) This class will look at various parts of the Arizona Revised Statutes",
  price: '$19.95'
}, {
  name: 'BMC #1 AZ Residential-Statutes and Rules',
  creditType: 'Comm. Standards',
  credits: 3,
  description: 'BMC#1 AZ Residential Statutes & Rules (CS) This is part 1 of the 3 required, 9 hour Broker Management',
  price: '$19.95'
}, {
  name: 'BMC #2 AZ Residential-Broker Policies',
  creditType: 'Comm. Standards',
  credits: 3,
  description: 'BMC#2 AZ Residential Broker Policies (CS) This is part 2 of the 3 required, 9 hour Broker Management Clinic required',
  price: '$19.95'
}, {
  name: 'BMC #3 AZ Residential-Broker Supervision',
  creditType: 'Comm. Standards',
  credits: 3,
  description: 'BMC#3 AZ Residential Broker Supervision (CS) This is part 3 of the 3 required, 9 hour Broker Management',
  price: '$19.95'
}, {
  name: 'BMC #3B Property Management',
  creditType: 'Comm. Standards',
  credits: 3,
  description: 'Broker Management Clinic #3B Property Management (CS) If the broker conducts or allows PROPERTY',
  price: '$19.95'
}, {
  name: 'What Goes Wrong In Contracts',
  creditType: 'Contract Law',
  credits: 3,
  description: 'What Goes Wrong In Contracts? (CL) A review of the common contract issues in residential',
  price: '$19.95'
}, {
  name: 'Avoid The Oops: Contract Smarts for Agents',
  creditType: 'Contract Law',
  credits: 3,
  description: 'Avoid The Oops: Contract Smarts For Agents (CL) A review of a valid, enforceable',
  price: '$19.95'
}];
export function Products() {
  return <div className="space-y-6" data-id="element-2276">
      {/* Page Title */}
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-2277">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-2278">
          On-Demand Packages / Single Classes
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-2279">
          Browse all available packages and individual classes.
        </p>
      </div>

      {/* Info Block */}
      <div className="text-sm text-slate-700 space-y-3 leading-relaxed" data-id="element-2280">
        <p data-id="element-2281">
          Your 24 hour requirement (every two years), includes 21 hours (7 class
          types), with at least one class (3 hrs) of each of the following
          credit types:
        </p>
        <ul className="space-y-0.5 pl-2" data-id="element-2282">
          <li data-id="element-2283">- Agency Law</li>
          <li data-id="element-2284">- Contract Law</li>
          <li data-id="element-2285">- Disclosure</li>
          <li data-id="element-2286">- Fair Housing</li>
          <li data-id="element-2287">- General Deed Fraud, Firewise &amp; AZ Water</li>
          <li data-id="element-2288">- Legal Issues</li>
          <li data-id="element-2289">
            - Requirements for Licensees (formerly Commissioner's Standards)
          </li>
          <li data-id="element-2290">
            - 1 class <strong data-id="element-2291">(3 hours) for elective credit</strong> You may
            choose any credit type, providing you do not duplicate any course
            you have already taken within that renewal period
          </li>
        </ul>
        <p data-id="element-2292">
          Designated, Self-employed Brokers and Associate Brokers with
          Supervisory responsibility are required to take 30 CE credits (every 2
          years) for license renewal (including Broker Management Clinic 1-3)
        </p>
        <p className="text-slate-600" data-id="element-2293">
          <strong data-id="element-2294">NOTE:</strong> ADRE requires that ALL 3 hr. CE classes, either
          Live or Distance Learning, run for a total of 150 minutes. As required
          by ADRE, all sections in a class is timed. When you begin a section,
          the timer will begin at 25 minutes. As long as your class is open and
          your browser is connected to the server, the timer will continue to
          count down. If you leave the class, your device goes to sleep, click
          on an outside link, or shut off your computer, the timer will stop and
          will begin again where you left off when you log back into the class.
        </p>
        <div data-id="element-2295">
          <button className="px-4 py-2 text-white text-sm font-bold rounded" style={{
          backgroundColor: '#E8A020'
        }} data-id="element-2296">
            CLICK HERE!
          </button>
          <span className="ml-2 text-slate-600" data-id="element-2297">For sample class</span>
        </div>
      </div>

      {/* On-Demand Packages */}
      <div data-id="element-2298">
        <h2 className="text-lg font-semibold text-slate-800 mb-3" data-id="element-2299">
          On-Demand Packages
        </h2>
        <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-2300">
          <div className="overflow-x-auto" data-id="element-2301">
            <table className="w-full text-sm text-left" data-id="element-2302">
              <thead style={{
              backgroundColor: '#4A2D8F'
            }} className="text-white font-medium" data-id="element-2303">
                <tr data-id="element-2304">
                  <th className="px-4 py-3 border-r border-purple-700" data-id="element-2305">
                    Package Name
                  </th>
                  <th className="px-3 py-3 border-r border-purple-700 text-center w-24" data-id="element-2306">
                    Credit Hours
                  </th>
                  <th className="px-3 py-3 border-r border-purple-700 text-center w-20" data-id="element-2307">
                    Price
                  </th>
                  <th className="px-3 py-3 text-center w-28" data-id="element-2308">Purchase</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200" data-id="element-2309">
                {packages.map((pkg, i) => <tr key={i} className="hover:bg-purple-50/30" data-id="element-2310">
                    <td className="px-4 py-2.5 border-r border-slate-200" data-id="element-2311">
                      <span className="text-slate-800" data-id="element-2312">{pkg.name}</span>
                      {pkg.hasDetails && <button className="ml-1 text-blue-600 hover:underline text-xs" data-id="element-2313">
                          Details
                        </button>}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-2314">
                      {pkg.credits}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-center font-medium" style={{
                  color: '#CC0000'
                }} data-id="element-2315">
                      {pkg.price}
                    </td>
                    <td className="px-3 py-2.5 text-center" data-id="element-2316">
                      <button className="px-3 py-1 text-white text-xs font-bold rounded" style={{
                    backgroundColor: '#2E7D32'
                  }} data-id="element-2317">
                        BUY NOW
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>

      {/* On-Demand Single Classes */}
      <div data-id="element-2318">
        <h2 className="text-lg font-semibold text-slate-800 mb-3" data-id="element-2319">
          On-Demand Single Classes
        </h2>
        <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-2320">
          <div className="overflow-x-auto" data-id="element-2321">
            <table className="w-full text-sm text-left" data-id="element-2322">
              <thead style={{
              backgroundColor: '#4A2D8F'
            }} className="text-white font-medium" data-id="element-2323">
                <tr data-id="element-2324">
                  <th className="px-4 py-3 border-r border-purple-700 w-44" data-id="element-2325">
                    Class Name
                  </th>
                  <th className="px-3 py-3 border-r border-purple-700 w-28" data-id="element-2326">
                    Credit Type
                  </th>
                  <th className="px-3 py-3 border-r border-purple-700 text-center w-16" data-id="element-2327">
                    Credit Hours
                  </th>
                  <th className="px-4 py-3 border-r border-purple-700" data-id="element-2328">
                    Description
                  </th>
                  <th className="px-3 py-3 border-r border-purple-700 text-center w-20" data-id="element-2329">
                    Price
                  </th>
                  <th className="px-3 py-3 text-center w-28" data-id="element-2330">Purchase</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200" data-id="element-2331">
                {singleClasses.map((cls, i) => <tr key={i} className="hover:bg-purple-50/30" data-id="element-2332">
                    <td className="px-4 py-2.5 border-r border-slate-200 font-medium text-slate-800" data-id="element-2333">
                      {cls.name}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-slate-600" data-id="element-2334">
                      {cls.creditType}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-2335">
                      {cls.credits}
                    </td>
                    <td className="px-4 py-2.5 border-r border-slate-200 text-slate-600 text-xs leading-relaxed" data-id="element-2336">
                      {cls.description}{' '}
                      <button className="text-blue-600 hover:underline" data-id="element-2337">
                        More &gt;
                      </button>
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-center font-medium" style={{
                  color: '#CC0000'
                }} data-id="element-2338">
                      {cls.price}
                    </td>
                    <td className="px-3 py-2.5 text-center" data-id="element-2339">
                      <button className="px-3 py-1 text-white text-xs font-bold rounded" style={{
                    backgroundColor: '#2E7D32'
                  }} data-id="element-2340">
                        BUY NOW
                      </button>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </div>;
}